import React, { Component } from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";

class CareersInfo extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";

    return (
      <div className="ltn__contact-address-area mb-90">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-4">
              <div className="ltn__contact-address-item ltn__contact-address-item-3 box-shadow">
                <div className="ltn__contact-address-icon">
                  <img
                    src={publicUrl + "assets/img/icons/10.png"}
                    alt="Icon Image"
                  />
                </div>
                <h3>Email Address</h3>
                <p>
                  careers@atom-power.com
                  {/* <br />
                  jobs@webexample.com */}
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="ltn__contact-address-item ltn__contact-address-item-3 box-shadow">
                <div className="ltn__contact-address-icon">
                  <img
                    src={publicUrl + "assets/img/icons/careers-icon.png"}
                    alt="Icon Image"
                  />
                </div>
                <h3>
                  Explore Careers <br /> <span>at</span> Wavetec
                </h3>
                <p>
                  <a
                    href="https://www.wavetec.com/about-us/careers/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View Open Roles
                  </a>
                </p>
              </div>
            </div>
            {/* <div className="col-lg-4">
              <div className="ltn__contact-address-item ltn__contact-address-item-3 box-shadow">
                <div className="ltn__contact-address-icon">
                  <img
                    src={publicUrl + "assets/img/icons/12.png"}
                    alt="Icon Image"
                  />
                </div>
                <h3>Office Address</h3>
                <p>
                  C3i GA-70-A3 Korangi Creek Industrial Park Korangi, Karachi,
                  Sindh
                </p>
              </div>
            </div> */}
            {/* <div className="col-lg-4">
              <div className="ltn__contact-address-item ltn__contact-address-item-3 box-shadow">
                <div className="ltn__contact-address-icon">
                  <img
                    src={publicUrl + "assets/img/icons/11.png"}
                    alt="Icon Image"
                  />
                </div>
                <h3>Phone Number</h3>
                <p>
                  +92-326-8314491
                </p>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    );
  }
}

export default CareersInfo;
